import { BookendType } from "constants"
import * as React from "react"
import { getFooterKey, getHeaderKey } from "./helpers"
import { REACT_COMP_VERSION, BOOKENDS_META_TAG_NAME } from "constants"


export const getHeaderComponentSlug = (headerType: BookendType) => {
  return `${headerType}_header`
}

export const getFooterComponentSlug = (footerType: BookendType) => {
  return `${footerType}_footer`
}

export const BookendsMetaTag = (props: {
  tenant: string, 
  locale: string, 
  headerType?: BookendType,
  footerType?: BookendType, 
  renderWith?: React.ComponentType<any>,
  hideSearch?: boolean, 
  hideVat?: boolean,
  showStickyHeader?: boolean,
  inlineCriticalCss?: boolean
}) => {
  const Comp = props.renderWith || React.Fragment
  return <Comp>
    <meta
      name={BOOKENDS_META_TAG_NAME}
      data-headercomponent={props.headerType ? getHeaderComponentSlug(props.headerType) : undefined}
      data-footercomponent={props.footerType ? getFooterComponentSlug(props.footerType) : undefined}
      data-headerkey={props.headerType ? getHeaderKey(props.tenant, props.locale, props.headerType, props.hideSearch, props.hideVat, props.showStickyHeader) : undefined}
      data-footerkey={props.footerType ? getFooterKey(props.tenant, props.locale, props.footerType) : undefined}
      data-inline-critical-css={props.inlineCriticalCss === true || false}
      data-react-bookends-major-version={REACT_COMP_VERSION}
    />
  </Comp>
}